import { render } from "./FormSelectorModal.vue?vue&type=template&id=77e65d39&scoped=true"
import script from "./FormSelectorModal.vue?vue&type=script&lang=ts"
export * from "./FormSelectorModal.vue?vue&type=script&lang=ts"

import "./FormSelectorModal.vue?vue&type=style&index=0&id=77e65d39&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-77e65d39"

export default script
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QToolbar,QToolbarTitle,QBtn,QCardSection,QList,QItem,QItemSection,QIcon,QItemLabel});qInstall(script, 'directives', {ClosePopup});
